export function request (params) {
  return {
    dollarVolume: 0,
    mpid: 'OTCM',
    name: 'Mock Name',
    shareVolume: 0,
    trades: 0
  }
}
